<!--
 * @Author: zhaoliang
 * @Date: 2025-07-28 14:09:17
 * @LastEditTime: 2026-02-27 11:43:01
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/PrivacySettings/index.vue
 *
-->
<template>
  <div class="h-box">
    <h1 class="global-title">{{ $t('mbs-select-privacysettings') }}</h1>
    <div class="privacy-settings">
      <div class="privacy-desc">{{ $t('privacysettings-description') }}</div>
      <div class="divider"></div>
      <p class="switch-box">
        <span>{{ $t('allow-third-tools') }}</span>
        <Switcher :value="thirdSwitchStatus" @change="handleThirdSwitchChange"></Switcher>
      </p>
      <div class="divider"></div>
      <p class="switch-box">
        <span>{{ $t('privacysettings-marketing') }}</span>
      </p>
      <p class="switch-box">
        <span>{{ $t('privacysettings-by-email') }}</span>
        <Switcher :value="emailSwitchStatus" @change="handleEmailSwitchChange"></Switcher>
      </p>
      <p class="switch-box">
        <span>{{ $t('privacysettings-by-notifications') }}</span>
        <Switcher :value="pushSwitchStatus" @change="handlePushSwitchChange"></Switcher>
      </p>
      <div class="divider"></div>
      <div class="privacy-statement">
        <!-- For information about 3rd party tools, and data storage visit the
        <router-link to="/privacypolicy" target="_blank" class="underline-link">{{
          $t('Privacy-Policy')
        }}</router-link>
        and
        <a
          :href="
            $i18n.locale === 'fr_CA'
              ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
              : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html'
          "
          target="_blank"
          class="underline-link"
          >{{ $t('notice') }}</a
        >. If you have any questions, please get in touch with Dragonpass, using the
        <router-link to="/account/contact" class="underline-link">contact us form</router-link>. -->
        <i18n-t keypath="third-tools-description" tag="p">
          <router-link to="/privacypolicy" target="_blank" class="underline-link">{{
            $t('Privacy-Policy')
          }}</router-link>
          <a
            :href="
              $i18n.locale === 'fr_CA'
                ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
                : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html'
            "
            target="_blank"
            class="underline-link"
            >{{ $t('visa-privacy-notice') }}</a
          >
          <router-link to="/feedback" class="underline-link">{{
            $t('contact-us-form')
          }}</router-link>
        </i18n-t>
      </div>
    </div>
  </div>
</template>
<script>
  import Switcher from './Switcher.vue';
  import { mapState } from 'vuex';
  export default {
    name: 'PrivacySettings',
    components: { Switcher },
    data() {
      return {
        thirdSwitchStatus: false,
        emailSwitchStatus: false,
        pushSwitchStatus: false,
      };
    },
    computed: {
      ...mapState(['userInfo']),
    },
    mounted() {
      this.getPrivacySetting();
    },
    methods: {
      handleThirdSwitchChange(value) {
        this.$loading.show();
        const params = {
          channel: 3,
          privacySetting: 1,
          status: value ? 1 : 2,
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        };
        this.$http.login
          .updatePrivacySetting(params)
          .then(res => {
            if (res.state === '11') {
              this.thirdSwitchStatus = value;
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          })
          .finally(() => {
            this.$loading.hide();
          });
      },
      handleEmailSwitchChange(value) {
        localStorage.setItem('needGetMarketingNotice', '0');
        this.$loading.show();
        const params = {
          channel: 3,
          privacySetting: 3,
          emailSwitchStatus: value ? 1 : 2,
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        };
        this.$http.login
          .updatePrivacySetting(params)
          .then(res => {
            if (res.state === '11') {
              this.emailSwitchStatus = value;
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          })
          .finally(() => {
            this.$loading.hide();
          });
      },
      handlePushSwitchChange(value) {
        localStorage.setItem('needGetMarketingNotice', '0');
        this.$loading.show();
        const params = {
          channel: 3,
          privacySetting: 3,
          pushSwitchStatus: value ? 1 : 2,
          lang: this.$i18n.locale,
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        };
        this.$http.login
          .updatePrivacySetting(params)
          .then(res => {
            if (res.state === '11') {
              this.pushSwitchStatus = value;
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          })
          .finally(() => {
            this.$loading.hide();
          });
      },
      async getPrivacySetting() {
        const res = await this.$http.login.getPrivacySetting({
          userId: this.userInfo?.userId ?? '',
          sessionId: this.userInfo?.sessionId ?? '',
          device: 'web',
        });
        if (res.state === '11') {
          this.thirdSwitchStatus = res.data.allowTracking === 1;
          this.emailSwitchStatus = res.data.allowReceivingGlobalVo?.emailSwitchStatus === 1;
          this.pushSwitchStatus = res.data.allowReceivingGlobalVo?.pushSwitchStatus === 1;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .h-box {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
    }

    .divider {
      // margin-top: 18px;
      margin-bottom: 18px;
      height: 1px;
      background-color: #d8dee1;
    }

    .privacy-settings {
      width: 80%;

      .privacy-desc {
        color: #667077;
        @include font(20px, 600);
        line-height: 28px;
        margin-bottom: 14px;
      }

      .switch-box {
        margin-bottom: 18px;
        @include font(18px, 400);
        line-height: 28px;
        color: #667077;
        display: flex;
        align-items: flex-start; /* 垂直居中 */

        span {
          width: 90%;
          margin-right: 40px;
          vertical-align: super;
        }
      }

      .privacy-statement {
        margin-top: 30px;
        @include font(18px, 400);
        line-height: 28px;
        color: #667077;

        .underline-link {
          color: #4d5761;
          font-weight: 700;
          text-decoration: underline;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .h-box {
      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 22px;
        padding: 0;
      }

      .privacy-settings {
        width: 100%;

        .privacy-desc {
          font-size: 16px;
          font-weight: 600;
          line-height: 22px;
        }

        .switch-box {
          margin-bottom: 16px;
          @include font(16px, 400);
          line-height: 22px;

          span {
            width: 80%;
            margin-right: 20px;
          }
        }

        .privacy-statement {
          margin-top: 22px;
          @include font(16px, 400);
          line-height: 22px;
        }
      }
    }
  }
</style>
